<div class="d-flex align-items-end justify-content-between">
    <span id="ssh-login-powered-by">Powered by <a href="{{ poweredBy () }}" target='_blank' >FastX</a></span>
    <span class="d-flex flex-column">
        <span  id="ssh-login-build-number">Build: <a href="{{ release () }}" target='_blank'>{{ build }} {{ advanced ? "Advanced" : "" }}</a></span>
        
    </span>
</div>
<span *ngIf="!advanced" class="mt-3 text-danger d-flex justify-content-center">{{ advancedDisabled }}</span>